import gql from 'graphql-tag'

export const UNIT_MUTATION_CREATE = gql`
  mutation CreateUnit($input: CreateUnitInput!) {
    createUnit(input: $input) {
      isSuccessful
      message
      unit {
        structureId
        parentId
        companyId
        name
        level
        isPosition
        hasRelation
        department {
          structureId
          name
        }
      }
    }
  }
`

export const UNIT_MUTATION_UPDATE = gql`
  mutation UpdateUnit($input: UpdateUnitInput!) {
    updateUnit(input: $input) {
      Unit {
        structureId
        parentId
        companyId
        name
        level
        isPosition
        hasRelation
        department {
          structureId
          name
        }
      }
      isSuccessful
      message
    }
  }
`

export const UNIT_MUTATION_DELETE = gql`
  mutation DeleteUnit($filter: DeleteUnitInput) {
    deleteUnit(filter: $filter) {
      isSuccessful
      message
      unit {
        hasRelation
        isPosition
        level
        name
      }
    }
  }
`

export const GET_UNIT = gql`
query Units($filter: GetUnitInput) {
  units(filter: $filter) {
    isSuccessful
    message
    Units {
      data {
        structureId
        parentId
        companyId
        name
        level
        isPosition
        hasRelation
        department {
          structureId
          name
        }
      }
      pagination {
        total
        page
        show
      }
    }
    status
  }
}
`
